import { createFileRoute } from '@tanstack/react-router';

import { MethodologyProvidersTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <MethodologyProvidersTab
      managedAccountMethodologyId={params.managedAccountMethodologyId}
    />
  );
};

export const Route = createFileRoute(
  '/methodologies/$managedAccountMethodologyId/managed-account-providers'
)({
  component: Page
});
